<template>
  <div class="tree-content-render">
    <div v-if="!isRadioFirstLevel">
      <el-checkbox-group v-model="checkedValues" @change="onChangeGroup">
        <div v-if="isCheckBoxButton">
          <el-checkbox-button
            v-for="o in childItems"
            :label="o[vFeild]"
            :key="o[vFeild]"
            @change="onChangeCheckbox"
            >{{ o[lFeild] }}</el-checkbox-button
          >
        </div>

        <div v-else>
          <el-checkbox
            v-for="o in childItems"
            :label="o[vFeild]"
            :key="o[vFeild]"
            @change="onChangeCheckbox"
            >{{ o[lFeild] }}</el-checkbox
          >
        </div>
      </el-checkbox-group>
    </div>

    <div v-else>
      <el-radio-group v-model="checkedValue" @change="onChangeRadioGroup">
        <div v-if="isCheckBoxButton">
          <el-radio-button label>不限</el-radio-button>

          <el-radio-button
            v-for="o in childItems"
            :label="o[vFeild]"
            :key="o[vFeild]"
            >{{ o[lFeild] }}</el-radio-button
          >
        </div>

        <div v-else>
          <el-radio
            v-for="o in childItems"
            :label="o[vFeild]"
            :key="o[vFeild]"
            >{{ o[lFeild] }}</el-radio
          >
        </div>
      </el-radio-group>
    </div>

    <!-- 循环 -->
    <div v-if="!_.isEmpty(primaryLevels)">
      <span class="label-level">{{ labelText }}</span>

      <div class="primary-levels">
        <tree-content-render
          :childItems.sync="primaryLevels"
          :parent-value.sync="checkedValues"
          @update:checkedValues="updateCheckedValues"
          :isCheckBoxButton="isCheckBoxButton"
          :parentInd="parentInd + 1"
          :vFeild="vFeild"
          :lFeild="lFeild"
          :cField="cField"
          :isFristLevel="false"
        ></tree-content-render>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 树形结构内容渲染
 * @param {Array} childItems 遍历的数组
 * @param {Array} parentValue 父级选中值
 * @param {Number} parentInd 父级层级
 * @param {Function} update:checkedValues 更新选中值
 * @param {String} vField 值字段名
 * @param {String} lField 标签字段名
 * @param {String} cField 子级字段名
 *
 */
export default {
  name: "TreeContentRender",
  props: {
    // 遍历的数组
    childItems: {
      type: Array,
      required: true
    },
    //父级选中值
    parentValue: {
      type: Array,
      default: () => []
    },
    // 父级层级
    parentInd: {
      type: Number,
      required: true
    },
    //子级字段名
    cField: {
      type: String,
      default: "children"
    },
    //值字段名
    vFeild: {
      type: String,
      default: "value"
    },
    //标签字段名
    lFeild: {
      type: String,
      default: "label"
    },
    // 是否为check-box-button
    isCheckBoxButton: {
      type: Boolean,
      default: false
    },
    // 第一级是否为单选
    isRadioFirstLevel: {
      type: Boolean,
      default: false
    },
    isFristLevel: {
      type: Boolean,
      default: true
    },
    limitLabels: {
      type: Array,
      default: () => []
    },
    isTree: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    //自定义标签展示文字
    labelText() {
      if (
        Array.isArray(this.limitLabels) &&
        typeof this.parentInd === "number"
      ) {
        if (this.limitLabels.length) {
          const text = this.limitLabels[this.parentInd - 1];

          return text || `${this.parentInd + 1}级标签：`;
        } else {
          return `${this.parentInd + 1}级标签：`;
        }
      } else {
        return "";
      }
    }
  },
  watch: {
    "childItems.length": {
      handler(newVal, oldVal) {
        this.handleNextPrimaryLevels();
      },
      deep: true
    },
    parentValue: {
      handler(newVal, oldVal) {
        this.$set(this, "checkedValues", newVal);

        if (this.isRadioFirstLevel && !this.isTree && newVal.length) {
          this.checkedValue = newVal[0];
          this.onChangeRadioGroup(newVal[0])
        } else {
          if (!this.isInit && newVal.length && this.isTree) {
            this.onChangeGroup(newVal);
            this.isInit = true;
          }
        }

        if (this.isTree) {
          if (!newVal.length) {
            this.clear();
          }
        } else {
          if (!newVal.filter(item => item !== "").length) {
            this.clear();
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      checkedValues: [],
      primaryLevels: [], //下一级需要显示的数组
      checkedValue: "",
      isInit: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.handleNextPrimaryLevels();
    });
  },
  methods: {
    clear() {
      this.checkedValues = [];
      this.checkedValue = "";
      this.primaryLevels = [];
    },
    updateCheckedValues(newCheckedValues) {
      this.checkedValues = newCheckedValues;
      this.$emit("update:checkedValues", this.checkedValues);
    },
    /**
     * 单选框组onchange
     * @param {String} e
     * 主要处理子级循环数据
     */
    onChangeRadioGroup(e) {
      let flag;

      if (Array.isArray(e)) {
        flag = e;
      } else {
        flag = [e];
      }

      let filterData = this.childItems.filter(item => {
        return _.includes(flag, item[this.vFeild]);
      });

      this.primaryLevels = filterData.reduce(
        (acc, cur) => acc.concat(cur[this.cField] || []),
        []
      );

      this.checkedValues = [e];
      this.updateCheckedValues(this.checkedValues);
    },
    /**
     * 复选框组onchange
     * @param {Array} val
     * 主要处理子级循环数据
     */
    onChangeGroup(val) {
      let filterData = this.childItems.filter(item =>
        _.includes(val, item[this.vFeild])
      );
      this.primaryLevels = filterData.reduce(
        (acc, cur) => acc.concat(cur[this.cField] || []),
        []
      );

      this.updateCheckedValues(this.checkedValues);
    },
    /**
     * 复选框onchange
     * @param {Boolean} val
     * @param {Object} event
     * 取消选中重新更新checkedValues
     */
    onChangeCheckbox(val, { target }) {
      //取消选中,是否有下级值有选中,有也需要剔除
      if (!val) {
        const currentNode = _.find(
          this.childItems,
          o => o[this.vFeild] == target.value
        );

        if (currentNode && !_.isEmpty(currentNode[this.cField])) {
          const needRemoveIds = this.extractIds(currentNode[this.cField]);
          if (!_.isEmpty(needRemoveIds)) {
            const values = _.difference(this.checkedValues, needRemoveIds);
            this.updateCheckedValues(values);
          }
        }
      }
    },
    //根据当前级数组变化 来决定下级显示数据;初始化也需要调用回显
    handleNextPrimaryLevels() {
      const childIds = this.childItems.map(o => o.id);
      //查看childsids与checkedValues是否有交集
      const intersection = _.intersection(childIds, this.checkedValues);
      //有交集取出交集数组重新赋值primaryLevels
      if (!_.isEmpty(intersection)) {
        let filterData = this.childItems.filter(item =>
          _.includes(intersection, item[this.vFeild])
        );
        this.primaryLevels = filterData.reduce(
          (acc, cur) => acc.concat(cur[this.cField] || []),
          []
        );
      } else {
        this.primaryLevels = [];
      }
    },
    //取出当前节点下所有的id
    extractIds(list) {
      const ids = [];
      const _this = this;
      // 定义递归函数来遍历列表
      function recursiveExtract(items) {
        for (let item of items) {
          ids.push(item[_this.vFeild]);
          if (item && !_.isEmpty(item[_this.cField])) {
            recursiveExtract(item[_this.cField]);
          }
        }
      }
      recursiveExtract(list);
      return ids;
    }
  }
};
</script>

<style lang="less" scoped>
.primary-levels {
  background-color: #f5f6f7;
  border-radius: 4px;
  padding-left: 4px;
}

.label-level {
  color: #7c7f8e;
}
</style>
